<section class="container">
    <h3 class="h3 font-weight-semi-bold pt-3">{{ title }}</h3>
    <div *ngIf="errorMessage" class="alert alert-warning">{{ errorMessage}}</div>
    <form class="mb-3" (submit)="addBlogEntry()" #newBlogEntryForm="ngForm" novalidate>
        <div class="form-group">
            <textarea rows="3" name="text" class="form-control mb-2" [(ngModel)]="blogEntry.text" #blogEntryText="ngModel" required></textarea>
            <div class="text-danger" *ngIf="blogEntryText.touched && blogEntryText.invalid && blogEntryText.errors.required">Blog text is required!</div>
        </div>
        <div class="form-group">
            <input class="btn btn-primary btn-sm mr-2" type="submit" value="Post" [disabled]="newBlogEntryForm.invalid" />
            <a class="btn btn-sm" routerLink="">Cancel</a>
        </div>
    </form>         
</section>